<template>
  <div>
    <div class="footer-container">
      <div class="footer-info">
        <p>联系我们</p>
        <p>地址：{{companyInfo.address}}</p>
        <p>电话：{{companyInfo.phone}}</p>
        <p>邮箱：{{companyInfo.mail}}</p>
      </div>
      <div class="wechat-code">
        <img :src="$img + companyInfo.wechatImg">
      </div>
    </div>
    <div class="beian-info">
      <div>
        <div>Blueape. All Rights Reserved. 潮州数字蓝猿科技有限公司 版权所有
          Copyright&copy; 2018 - {{getYear}}
        </div>
          <p @click="to_beian">粤ICP备2023112699号</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "mbFooter",
    data() {
      return {
        companyInfo: {},
        getYear: ''
      }
    },
    created() {
      this.$http.get('/api/company/info/list').then((res) => {
        this.companyInfo = res.data.rows[0]
      })
      let timer = new Date()
      this.getYear = timer.getFullYear()
    },
    methods: {
      to_beian() {
        window.open('https://beian.miit.gov.cn/', "_blank")
      }
    }
  }
</script>

<style scoped>
  .footer-container {
    height: 33.6vw;
    background-color: #1c1b21;
    position: relative;
    /*top: -1px;*/
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .footer-info {
    color: #888;
    font-size: .625em;
    line-height: 180%;
    padding: 0 0 0 5.6vw;
  }

  .wechat-code {
    width: 16vw;
    height: 16vw;
    margin: 0 8vw 0 0;
  }

  .wechat-code img {
    width: 100%;
    height: 100%;
  }

  .beian-info {
    background-color: #1c1b21;
    color: #888;
    font-size: .625em;
    line-height: 150%;
    text-align: center;
    padding-bottom: 5vw;
  }

  .beian-info div {
    transform: scale(0.9);

  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/mbFooter.vue